(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  const menuBtn = $("[data-menu-toggle]");
  const menu = $("[data-mobile-nav]");
  if (menuBtn && menu) {
    menuBtn.addEventListener("click", () => {
      const open = menu.hasAttribute("hidden") === false;
      menu.toggleAttribute("hidden", open);
      menuBtn.setAttribute("aria-expanded", String(!open));
    });
  }

  const searchBtn = $("[data-search-toggle]");
  const search = $("[data-search-panel]");
  if (searchBtn && search) {
    searchBtn.addEventListener("click", () => {
      const open = search.hasAttribute("hidden") === false;
      search.toggleAttribute("hidden", open);
      searchBtn.setAttribute("aria-expanded", String(!open));
      if (!open) {
        const input = $("input[type='search']", search);
        if (input) input.focus();
      }
    });
  }

  $$("[data-qty]").forEach((wrap) => {
    const input = $("input[name='quantity']", wrap);
    wrap.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-qty-btn]");
      if (!btn || !input) return;
      const delta = Number(btn.dataset.qtyBtn);
      const min = Number(input.min || 1);
      const next = Math.max(min, Number(input.value || 1) + delta);
      input.value = String(next);
    });
  });

  const main = $("[data-gallery-main]");
  $$("[data-gallery-thumb]").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (!main) return;
      main.src = btn.dataset.galleryThumb;
      if (btn.dataset.gallerySrcset) main.srcset = btn.dataset.gallerySrcset;
      $$("[data-gallery-thumb]").forEach((b) => b.setAttribute("aria-current", "false"));
      btn.setAttribute("aria-current", "true");
    });
  });
})();
